import { Button, Col, FormCheck, FormGroup, FormLabel, Row } from "react-bootstrap";
import InputText from "../../../components/Forms/Element/InputText";
import StatusCheckBox from "../../../components/Common/StatusCheckbox";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { convertArrayBufferToBlob, convertStatusToBoolean } from "../../../../utils/ConverterUtils";
import InputPassword from "../../../components/Forms/Element/InputPassword";
import GroupSelect from "../../../components/Custom/Identity/Group/GroupSelect";
import ImagePreview from "../../../components/Common/ImagePreview";
import Common from "../../../../constants/Common";
import { downloadUploadFile } from "../../../../services/AxiosService";
import Api from "../../../../constants/Api";
import AsteriskRequired from "../../../components/Common/AsteriskRequired";
import BranchMultiSelect from "../../../components/Custom/Main/Branch/BranchMultiSelect";
import FormSection from "../../../components/Common/Form/FormSection";

const Form = (props) => {
    const { t } = useTranslation();
    const { status, setStatus, formik, entityData, blockUser, promoteToAdmin, setPromoteToAdmin, setBlockUser, setUploadedFile, uploadedFile } = props;
    const [blockedPassword, setBlockedPassword] = useState(false);
    const [showLoading, setShowLoading] = useState(false);

    const unlockPasswordEdition = () => {
        setBlockedPassword(false);
        formik.setFieldValue('password', '');
        formik.setFieldValue('passwordConfirmation', '');
    };

    useEffect(() => {
        // Preenche os valores nos campos.
        if (entityData != null) {
            formik.setFieldValue('firstName', entityData.firstName);
            formik.setFieldValue('lastName', entityData.lastName);
            formik.setFieldValue('email', entityData.email);
            formik.setFieldValue('password', "**********");
            formik.setFieldValue('passwordConfirmation', "**********");
            setStatus(convertStatusToBoolean(entityData.status));

            setBlockedPassword(true);
            setBlockUser(entityData.blocked);
            setPromoteToAdmin(entityData.admin);

            if (entityData.group !== null) {
                formik.setFieldValue('group', {
                    value: entityData.group.id,
                    label: entityData.group.name
                });
            }

            if (entityData.branches !== null && entityData.branches.length > 0) {
                let branches = [];

                entityData.branches.forEach(branch => {
                    branches.push(
                        { value: branch.id, label: branch.name }
                    );
                });

                formik.setFieldValue('branches', branches);
            }

            if (entityData.photo !== null && entityData.photo !== undefined && entityData.photo !== '') {
                setShowLoading(true);
                downloadUploadFile(Api.identity.user + "/download", entityData.id)
                    .then(resp => {
                        if (resp.data) {
                            setUploadedFile(convertArrayBufferToBlob(resp.data));
                        }
                    })
                    .catch(() => {
                        // Arquivo não encontrado no S3 (ex.: registro antigo) - não trava o usuário com erro.
                    })
                    .finally(() => setShowLoading(false));
            }
        } else {
            setBlockedPassword(false);
            setShowLoading(false);
        }

        // eslint-disable-next-line
    }, [entityData]);

    useEffect(() => {
        if (promoteToAdmin !== undefined && promoteToAdmin) {
            formik.setFieldValue("group", null);
        }
    }, [promoteToAdmin]);

    return (
        <>
            <div className="form-layout form-layout--spaced">
                <FormSection
                    title={t('basic_information')}
                    description={t('user_basic_information_hint')}
                    icon="fa-solid fa-user"
                >
                    <Row className="g-3 align-items-start">
                        <Col lg={2} md={3}>
                            <div className="avatar-upload-wrap">
                                <ImagePreview
                                    id="file"
                                    permittedWidth={Common.PROFILE_IMAGE_PERMITTED_WIDTH}
                                    permittedHeight={Common.PROFILE_IMAGE_PERMITTED_HEIGHT}
                                    permittedSize={Common.PROFILE_IMAGE_PERMITTED_FILE_SIZE}
                                    setUploadedFile={setUploadedFile}
                                    uploadedFile={uploadedFile}
                                    showLoading={showLoading}
                                />
                                <span className="avatar-upload-label">{t('picture')}</span>
                            </div>
                        </Col>
                        <Col lg={10} md={9}>
                            <Row className="g-3">
                                <Col md={6} xl={4}>
                                    <FormGroup>
                                        <FormLabel>{t('firstName')} <AsteriskRequired /></FormLabel>
                                        <InputText
                                            name="firstName"
                                            placeholder={t('firstName_placeholder')}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.firstName}
                                            error={formik.errors.firstName}
                                            maxlength="50"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={6} xl={4}>
                                    <FormGroup>
                                        <FormLabel>{t('lastName')} <AsteriskRequired /></FormLabel>
                                        <InputText
                                            name="lastName"
                                            placeholder={t('lastName_placeholder')}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.lastName}
                                            error={formik.errors.lastName}
                                            maxlength="50"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={6} xl={4}>
                                    <FormGroup>
                                        <FormLabel>{t('email')} <AsteriskRequired /></FormLabel>
                                        <InputText
                                            name="email"
                                            placeholder={t('email_placeholder')}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.email}
                                            error={formik.errors.email}
                                            maxlength="50"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </FormSection>

                <FormSection
                    title={t('password')}
                    description={t('user_password_hint')}
                    icon="fa-solid fa-lock"
                    actions={blockedPassword && (
                            <Button
                                variant="outline-primary"
                                size="sm"
                                type="button"
                                onClick={unlockPasswordEdition}
                                className="d-inline-flex align-items-center fw-semibold"
                            >
                                <i className="fa fa-key me-2"></i>{t('edit_password')}
                            </Button>
                    )}
                >

                    <Row className="g-3">
                        <Col md={6}>
                            <FormGroup>
                                <FormLabel>{t('password')} <AsteriskRequired /></FormLabel>
                                <InputPassword
                                    name="password"
                                    disabled={blockedPassword}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.password}
                                    error={formik.errors.password}
                                    maxlength="50"
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <FormLabel>{t('password_confirmation')} <AsteriskRequired /></FormLabel>
                                <InputPassword
                                    name="passwordConfirmation"
                                    disabled={blockedPassword}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.passwordConfirmation}
                                    error={formik.errors.passwordConfirmation}
                                    maxlength="50"
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </FormSection>

                <FormSection
                    title={t('actions')}
                    description={t('user_access_rules_hint')}
                    icon="fa-solid fa-user-shield"
                >

                    <Row className="g-3">
                        <Col md={6}>
                            <FormCheck className="mb-0">
                                <input
                                    id="block"
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={blockUser}
                                    onChange={() => setBlockUser(!blockUser)}
                                />
                                <FormLabel htmlFor="block" className="form-check-label">
                                    {t('block_user')}
                                </FormLabel>
                            </FormCheck>
                        </Col>
                        <Col md={6}>
                            <FormCheck className="mb-0">
                                <input
                                    id="promoteAdmin"
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={promoteToAdmin}
                                    onChange={() => setPromoteToAdmin(!promoteToAdmin)}
                                />
                                <FormLabel htmlFor="promoteAdmin" className="form-check-label">
                                    {t('promote_user_to_administrator')}
                                </FormLabel>
                            </FormCheck>
                        </Col>
                    </Row>
                </FormSection>

                <FormSection
                    title={t('group')}
                    description={t('user_group_hint')}
                    icon="fa-solid fa-users"
                >

                    <Row className="g-3">
                        <Col md={6} xl={4}>
                            <FormGroup>
                                <FormLabel>{t('group')}</FormLabel>
                                <GroupSelect
                                    name="group"
                                    value={formik.values.group}
                                    onChange={(value) => formik.setFieldValue('group', value)}
                                    onBlur={formik.handleBlur}
                                    error={formik.errors.group}
                                    isDisabled={promoteToAdmin}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </FormSection>

                <FormSection
                    title={t('branches')}
                    description={t('user_branches_hint')}
                    icon="fa-solid fa-code-branch"
                >

                    <Row className="g-3">
                        <Col md={6} xl={4}>
                            <FormGroup>
                                <FormLabel>{t('branches')}</FormLabel>
                                <BranchMultiSelect
                                    name="branches"
                                    value={formik.values.branches}
                                    onChange={(value) => formik.setFieldValue('branches', value)}
                                    onBlur={formik.handleBlur}
                                    error={formik.errors.branches}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </FormSection>

                <FormSection
                    title={t('status')}
                    description={t('user_status_hint')}
                    icon="fa-solid fa-toggle-on"
                    compact
                >

                    <Row>
                        <Col md={12}>
                            <FormGroup className="mb-0">
                                <StatusCheckBox
                                    name="status"
                                    defaultChecked={status}
                                    checked={status}
                                    onClick={() => setStatus(!status)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </FormSection>
            </div>
        </>
    );
}

export default Form;
